import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { EventTimer } from '../Countdown/EventTimer'
import { useEvent } from '../../hooks/useEvent'
import CallService from '../../services/callService'
import { WithCountdown } from '../../hooks/use-countdown'
import { useEventById } from '../../hooks/use-event-by-id'
import { ReadEvent } from '../../schemas/event-schemas'

const FinishEventUpdatedSchema = ReadEvent.pick({
  secondsUntilFinish: true,
  secondsUntilStartClosing: true,
})

export function FinishEventCountdown() {
  const { t } = useTranslation()
  const { close } = useEvent()
  const { data: event, updateFinishAtEvent } = useEventById()
  const [closingStarted, setClosingStarted] = useState(false)

  const onFinishEventUpdated = (payload) => {
    const result = FinishEventUpdatedSchema.safeParse(payload)
    if (result.success) {
      updateFinishAtEvent(result.data)
    } else {
      console.error('Invalid payload for finishEventUpdated:', result.error)
    }
  }

  useEffect(() => {
    CallService.setFinishEventCountdownMessageHandler(onFinishEventUpdated)
  }, [])

  useEffect(() => {
    if (event === undefined || event.secondsUntilStartClosing === null) return

    let timeoutId

    if (event.secondsUntilStartClosing <= 0) {
      console.debug('Closing has already started')
      setClosingStarted(true)
    } else {
      // Ensure closingStarted is false before scheduling
      setClosingStarted(false)
      console.debug('Scheduling closing start in', event.secondsUntilStartClosing, 'seconds')
      timeoutId = setTimeout(() => {
        console.debug('Closing period has started')
        setClosingStarted(true)
      }, event.secondsUntilStartClosing * 1000)
    }

    return () => {
      if (timeoutId) {
        console.debug('Clearing scheduled closing start timeout')
        clearTimeout(timeoutId)
      }
    }
  }, [event.secondsUntilStartClosing])

  if (!event || event.secondsUntilFinish === null || closingStarted === false) return null

  return (
    <WithCountdown
      finishAt={event.secondsUntilFinish}
      onFinish={() => {
        close('EVENT COUNTDOWN FINISHED')
      }}
    >
      {event.secondsUntilFinish > 0 && (
        <EventTimer
          title={t('countdown.finishEventTimerHeader')}
          subtitle={t('countdown.finishEventTimerSecondaryHeader')}
          finishAt={event.secondsUntilFinish}
        />
      )}
    </WithCountdown>
  )
}
